import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';
import { broadcastCustomerRestrictionApi } from '../../api';
import { IUpdateBroadcastRestrictionsPayload } from './use-update-broadcast-restrictions.types';

export const useUpdateBroadcastCustomerRestrictions = () => {
  const updateBroadcastCustomerRestrictionsMutation = useMutation({
    mutationKey: ['update-broadcast-customer-restrictions'],
    gcTime: 1,
    mutationFn: (data: IUpdateBroadcastRestrictionsPayload) => broadcastCustomerRestrictionApi.upsertBroadcastCustomerRestriction({
      broadcastId: data.broadcastId,
      upsertBroadcastCustomerRestriction: data.restrictions,
    }),
  });

  const updateBroadcastCustomerRestrictions = useCallback((payload: IUpdateBroadcastRestrictionsPayload) => {
    updateBroadcastCustomerRestrictionsMutation.mutate(payload);
  }, [updateBroadcastCustomerRestrictionsMutation]);

  return {
    updateBroadcastCustomerRestrictions,
    updateBroadcastCustomerRestrictionsMutation,
  };
};
